import { CustomCellRendererProps } from "ag-grid-react";

interface StatusBadgeParams extends CustomCellRendererProps {
    value: string;  // The status name passed from valueGetter
}

const StatusBadgeRenderer = (params: StatusBadgeParams) => {
    const status = params.value?.toString().toLowerCase();

    return (
      <span
        className={`badge background-${
          status === "planned"
            ? "planned"
            : status === "completed"
            ? "completed"
            : status === "no show"
            ? "noshow"
            : status === "rescheduled"
            ? "rescheduled"
            : "cancelled"
        }`}
      >
        {params.value}
      </span>
    );
};

export default StatusBadgeRenderer;
